export const HOS_CONNECT_URL = "https://developer.hosconnect.com";

export const isHosConnectPlatform = (platform: {
  methods: { url: string }[];
}): boolean =>
  platform.methods.some((method) => method.url === HOS_CONNECT_URL);
